import { render, staticRenderFns } from "./Button.global.vue?vue&type=template&id=37ad35ea&"
import script from "./Button.global.vue?vue&type=script&lang=js&"
export * from "./Button.global.vue?vue&type=script&lang=js&"
import style0 from "./Button.global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports